import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  request: redukers.request({
    start: actionTypes.FETCH_VENDOR_DETAILS,
    success: actionTypes.FETCH_VENDOR_DETAILS_SUCCESS,
    error: actionTypes.FETCH_VENDOR_DETAILS_ERROR,
  }),
  vendorId: redukers.value({
    set: actionTypes.GET_VENDOR_ID,
  }),
  vendorInfo: redukers.value({
    set: actionTypes.GET_VENDOR_INFO,
    reset: actionTypes.RESET_VENDOR_INFO,
  }),
})
